import { NgModule } from "@angular/core";
import { RegistrationComponent } from "./registration/registration.component";
import { CommonModule, DatePipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { RegistrationService } from "../core/api-services/user-profile/registration.service";
import { ProfileContactInfo } from "./shared/profile-contact-info/profile-contact-info";
import { SharedModule } from "../shared/shared-module/shared-module.module";
import { InputComponentsModule } from "../shared/input-components/input-components.module";
import { ProfilePersonInfoComponent } from "./shared/profile-person-info/profile-person-info.component";
import { ProfileCompanyInfoComponent } from "./shared/profile-company-info/profile-company-info.component";
import { ProfileCompanyLocationComponent } from "./shared/profile-company-location/profile-company-location.component";
import { ProfileCompanyOwnersComponent } from "./shared/profile-company-owners/profile-company-owners.component";
import { ProfileMapper } from "./shared/profile-mapper";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { UserProfileService } from "../core/api-services/user-profile/user-profile.service";
import { ProfileAgentsComponent } from "./shared/profile-agents/profile-agents.component";
import { NgxPaginationModule } from "ngx-pagination";
import { LoginUaepassComponent } from './login-uaepass/login-uaepass.component';
import { UserTypesComponent } from './user-types/user-types.component';
import { UserTypesService } from "../core/api-services/user-profile/user-types.service";
import { LoginDashboardComponent } from './login-dashboard/login-dashboard.component';
import { UaepassLoginErrorComponent } from './uaepass-login-error/uaepass-login-error.component';
import { RouterModule, Routes } from "@angular/router";
import { ProfileAccountInfoComponent } from './shared/profile-account-info/profile-account-info.component';

const approutes: Routes = [];

@NgModule({
    declarations:[
        RegistrationComponent,
        UserProfileComponent,
        ProfilePersonInfoComponent,
        ProfileContactInfo,
        ProfileCompanyInfoComponent,
        ProfileCompanyLocationComponent,
        ProfileCompanyOwnersComponent,
        ProfileAgentsComponent,
        LoginUaepassComponent,
        UserTypesComponent,
        LoginDashboardComponent,
        UaepassLoginErrorComponent,
        ProfileAccountInfoComponent
    ],
    imports:[
        CommonModule,
        RouterModule.forChild(approutes),
        SharedModule,
        InputComponentsModule,
        TranslateModule.forChild(),
        NgxPaginationModule,
    ],
    providers:[
        RegistrationService,
        UserProfileService,
        UserTypesService,
        ProfileMapper,
        DatePipe
    ]
})

export class UserProfileModule{
}